import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMagnifyingGlassChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17 17",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M13.813 6.906a6.89 6.89 0 0 1-1.329 4.074l4.204 4.207a1.064 1.064 0 0 1-1.504 1.504l-4.204-4.207a6.867 6.867 0 0 1-4.074 1.329A6.905 6.905 0 0 1 0 6.905 6.905 6.905 0 0 1 6.906 0a6.905 6.905 0 0 1 6.907 6.906Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h17v17H0z"
		})
	}) })]
});
export default SvgIconMagnifyingGlassChart;
